export const ADMIN = "admin";
export const MEMBER = "user";
export const NO_ACCESS = "no_access";
export const NO_ENVIRONMENT = "No Environment";
export const ALL_ENVIRONMENTS = "All Environments";
